// Virtual numeric keyboard for VR devices

import React from 'react';
import styles from './VirtualKeyboard.module.css';

const VirtualKeyboard = ({ onKeyPress }) => {
  const keys = [
    ['1', '2', '3'],
    ['4', '5', '6'],
    ['7', '8', '9'],
    ['', '0', 'backspace']
  ];

  const handleKeyClick = (key) => {
    if (key && onKeyPress) {
      onKeyPress(key);
    }
  };

  return (
    <div className={styles.keyboard}>
      {keys.map((row, rowIndex) => (
        <div key={rowIndex} className={styles.row}>
          {row.map((key, keyIndex) => (
            <button
              key={keyIndex}
              onClick={() => handleKeyClick(key)}
              className={`${styles.key} ${key === 'backspace' ? styles.backspace : ''}`}
              disabled={!key}
            >
              {key === 'backspace' ? '⌫' : key}
            </button>
          ))}
        </div>
      ))}
    </div>
  );
};

export default VirtualKeyboard;
